import {
  Button,
  Chip,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { MailContent } from "./MailContent";
import { BsEnvelopeOpen, BsFillSendArrowUpFill } from "react-icons/bs";

export const MailLogTable = ({
  data,
  loading,
  handleChangePage,
  handleRequeue,
}) => {
  const [mailContent, setMailContent] = useState(null);

  const resolveStatusColor = (status) => {
    switch (status) {
      case "SENT":
        return "#4caf50";
      case "FAILED":
        return "#cf2020";
      case "PENDING":
        return "#FFA500";
      case "PROCESSING":
        return "#3838cfff";
      default:
        return "grey";
    }
  };

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Испраќач</b>
            </TableCell>
            <TableCell>
              <b>Примач/и</b>
            </TableCell>
            <TableCell>
              <b>Наслов</b>
            </TableCell>
            <TableCell align="center">
              <b>Re-queued</b>
            </TableCell>
            <TableCell>
              <b>Испратена на</b>
            </TableCell>
            <TableCell>
              <b>Датум на креирање</b>
            </TableCell>
            <TableCell>
              <b>Датум на модификација</b>
            </TableCell>
            <TableCell align="center">
              <b>Статус</b>
            </TableCell>
            <TableCell align="center">
              <b>Акции</b>
            </TableCell>
          </TableRow>
        </TableHead>
        {!loading &&
          data?.content?.map((log, index) => (
            <TableRow
              key={log.id}
              style={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
              }}
            >
              <TableCell>{log.sender}</TableCell>
              <TableCell>{log.receivers?.join(", ")}</TableCell>
              <TableCell>{log.subject}</TableCell>
              <TableCell align="center">
                {log.reQueued ? log.reQueued : 0}
              </TableCell>
              <TableCell style={{ width: "30px" }}>
                {log.dateSent
                  ? moment(log.dateSent).format("DD.MM.YYYY HH:mm:ss")
                  : "/"}
              </TableCell>{" "}
              <TableCell style={{ width: "30px" }}>
                {log.dateCreated
                  ? moment(log.dateCreated).format("DD.MM.YYYY HH:mm:ss")
                  : "/"}
              </TableCell>
              <TableCell style={{ width: "30px" }}>
                {log.dateModified
                  ? moment(log.dateModified).format("DD.MM.YYYY HH:mm:ss")
                  : "/"}
              </TableCell>
              <TableCell align="center">
                {log.status ? (
                  <Tooltip title={log?.failureReason || ""} arrow>
                    <Chip
                      label={log.status}
                      style={{
                        color: "white",
                        backgroundColor: resolveStatusColor(log.status),
                      }}
                    />
                  </Tooltip>
                ) : (
                  "/"
                )}
              </TableCell>
              <TableCell align="center">
                <Button
                  size="small"
                  color="primary"
                  variant="contained"
                  startIcon={<BsEnvelopeOpen />}
                  onClick={() => {
                    setMailContent(log?.content);
                  }}
                >
                  Отвори
                </Button>
                {log.status === "FAILED" && (
                  <Button
                    size="small"
                    color="warning"
                    variant="contained"
                    startIcon={<BsFillSendArrowUpFill />}
                    sx={{ mt: 0.5 }}
                    onClick={() => {
                      handleRequeue(log?.id);
                    }}
                  >
                    Препрати
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        {!loading && data?.content?.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} align="center">
              Не се пронајдени податоци.
            </TableCell>
          </TableRow>
        )}
        <TableRow>
          <TableCell colSpan={9}>
            <TablePagination
              rowsPerPageOptions={[15]}
              component="div"
              count={data?.totalElements}
              rowsPerPage={data?.size}
              page={data?.number}
              onPageChange={handleChangePage}
            />
          </TableCell>
        </TableRow>
      </Table>
      {mailContent && (
        <MailContent
          content={mailContent}
          open={Boolean(mailContent)}
          handleClose={() => setMailContent(null)}
        />
      )}
    </>
  );
};
